import { PLAY_PARAM_MATCHER } from '$src/generated/play_practise_params/paramMatchers';
import type { ParamMatcher } from '@sveltejs/kit';

export const match: ParamMatcher = (value: string) => {
    return PLAY_PARAM_MATCHER.has(value);
};
